export default "__VITE_ASSET__Du741zjG__"